import confirmItemActionAllowed from '../utils/confirmItemActionAllowed';
import { lazyReplyToMessage } from 'owa-mail-compose-store';
import * as mailModuleOrchestrator from 'owa-mail-module-orchestrator';
import { ClientItemId } from 'owa-client-ids';
import IRMRestrictions from 'owa-mail-store/lib/store/schema/IRMRestrictions';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import { action } from 'satcheljs/lib/legacy';
import { InstrumentationContext } from 'owa-mail-store';
import { ActionSource } from 'owa-mail-store';

export default action('replyToItem')(async function replyToItem(
    itemId: ClientItemId,
    isReplyAll: boolean,
    instrumentationContexts: InstrumentationContext[],
    actionSource: ActionSource
) {
    const restrictionToConfirm = <IRMRestrictions>{
        ReplyAllAllowed: isReplyAll,
        ReplyAllowed: !isReplyAll,
    };
    if (
        confirmItemActionAllowed(
            itemId.Id,
            restrictionToConfirm,
            format(
                strings.irm_actionNotAllowedOnThisItem,
                isReplyAll ? strings.itemHeaderReplyAll : strings.itemHeaderReply
            )
        )
    ) {
        lazyReplyToMessage.importAndExecute({
            referenceItemId: itemId,
            isReplyAll: isReplyAll,
            useFullCompose: true,
            actionSource: actionSource,
            instrumentationContexts: instrumentationContexts,
        });

        mailModuleOrchestrator.lazyOnReplyOrReplyAllOrForwardMessage.importAndExecute();
    }
});
